var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval53DError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 88 49",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M14 35c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14s-6.268 14-14 14H28c-7.732 0-14-6.268-14-14Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M60 23H28c-6.627 0-12 5.373-12 12s5.373 12 12 12h32c6.627 0 12-5.373 12-12s-5.373-12-12-12Zm-32-2c-7.732 0-14 6.268-14 14s6.268 14 14 14h32c7.732 0 14-6.268 14-14s-6.268-14-14-14H28Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M11 35c0 3.314-2.239 6-5 6s-5-2.686-5-6 2.239-6 5-6 5 2.686 5 6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M6 30c-2.046 0-4 2.06-4 5s1.954 5 4 5h1a1 1 0 1 1 0 2H6c-3.477 0-6-3.313-6-7 0-3.688 2.523-7 6-7h1a1 1 0 0 1 0 2H6Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M77 35c0-3.314 2.239-6 5-6s5 2.686 5 6-2.239 6-5 6-5-2.686-5-6Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M82 40c2.046 0 4-2.06 4-5s-1.954-5-4-5h-1a1 1 0 1 1 0-2h1c3.477 0 6 3.313 6 7 0 3.688-2.523 7-6 7h-1a1 1 0 1 1 0-2h1Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34.666 13.5a2.5 2.5 0 0 1-2.5 2.5H20.5a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 20.5 1h14.166v12.5ZM52.334 13.5a2.5 2.5 0 0 1-2.5 2.5H38.166a2.5 2.5 0 0 1-2.5-2.5V1h16.666v12.5ZM70 13.5a2.5 2.5 0 0 1-2.5 2.5H55.833a2.5 2.5 0 0 1-2.5-2.5V1H67.5A2.5 2.5 0 0 1 70 3.5v10Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M18 12a1 1 0 0 1-1-1V3.5A3.5 3.5 0 0 1 20.5 0h47A3.5 3.5 0 0 1 71 3.5V11a1 1 0 1 1-2 0V3.5A1.5 1.5 0 0 0 67.5 2h-47A1.5 1.5 0 0 0 19 3.5V11a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgOval53DError.viewBox = '0 0 88 49';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval53DError);
export default ForwardRef;